export const RISK_ASSESSMENT_SECTION_8_ID = '8'

export function shouldShowRiskAssessmentSection8StaleCallout(
  isSection8Expired: boolean | null | undefined
): boolean {
  return isSection8Expired === true
}
